import { Controller } from "@hotwired/stimulus"

const EVENT_NAME = "click_cta"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.trackClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.trackClick)
  }

  trackClick = (event) => {
    const link = event.target.closest("a")
    if (!link) return

    const href = link.getAttribute("href") || ""
    const target = link.getAttribute("target") || ""
    const ctaName = link.dataset.ctaName
    const ctaType = link.dataset.ctaType
    
    let trackEvent = false
    let eventData = {}

    // Check explicitly marked CTAs first
    if (ctaName) {
      trackEvent = true
      eventData = {
        cta_type: ctaType || "other",
        cta_text: ctaName,
        cta_url: href
      }
    } 
    // Otherwise fallback to automatic detection of WhatsApp
    else if (href.includes("wa.me")) {
      const text = link.innerText.trim() || link.getAttribute("aria-label") || "WhatsApp"
      trackEvent = true
      eventData = {
        cta_type: "whatsapp",
        cta_text: text,
        cta_url: href
      }
    }

    if (trackEvent) {
      if (typeof window.gtag === "function") {
        if (target === "_blank") {
          // New tab: Send immediately without delaying navigation
          window.gtag("event", EVENT_NAME, eventData)
        } else {
          // Same tab: Prevent default and delay navigation until callback or timeout
          event.preventDefault()
          
          let navigated = false
          const callback = () => {
            if (!navigated) {
              navigated = true
              window.location.href = href
            }
          }

          window.gtag("event", EVENT_NAME, {
            ...eventData,
            event_callback: callback,
            event_timeout: 2000
          })
        }
      } else {
        console.warn(`gtag is not defined, but ${EVENT_NAME} was triggered:`, eventData)
      }
    }
  }
}
